module.exports = __webpack_public_path__ + "img/circuit-line-long.0c530286.svg";